import memoize from 'react-utils/memoize';

type fieldStringFn = (field: string) => string;

const capitalize = (str: string): string => str[0].toUpperCase() + str.slice(1);

const uncapitalize = (str: string): string =>
  str[0].toLowerCase() + str.slice(1);

export const getDefaultPropName: fieldStringFn = memoize(
  // @ts-expect-error Memoize supports number & string, but we only support string
  (field) => `default${capitalize(field)}`
);

export const getOnChangeName: fieldStringFn = memoize((field) => {
  if (field === 'value') {
    return 'onChange';
  }
  // @ts-expect-error Memoize supports number & string, but we only support string
  return `on${capitalize(field)}Change`;
});

export const getPropFromDefaultName: fieldStringFn = memoize((defaultProp) => {
  if (!defaultProp) {
    return '';
  }
  // @ts-expect-error Memoize supports number & string, but we only support string
  return uncapitalize(defaultProp.replace('default', ''));
});
